import React from 'react'
import Svg from '../../../../packages/uikit/src/components/Svg/Svg'
import { SvgProps } from '../../../../packages/uikit/src/components/Svg/types'

const Icon: React.FC<SvgProps> = (props) => (
  <Svg width="22" height="22" viewBox="0 0 22 22" fill="none" {...props}>
    <rect width="8.25" height="4.125" fill="white" />
    <rect x="4.125" width="8.25" height="4.125" transform="rotate(90 4.125 0)" fill="white" />
    <rect width="8.25" height="4.125" transform="matrix(-1 0 0 1 22 0)" fill="white" />
    <rect width="8.25" height="4.125" transform="matrix(4.37114e-08 1 1 -4.37114e-08 17.875 0)" fill="white" />
    <rect width="8.25" height="4.125" transform="matrix(1 1.74846e-07 1.74846e-07 -1 0 22)" fill="white" />
    <rect width="8.25" height="4.125" transform="matrix(1.31134e-07 -1 -1 -1.31134e-07 4.125 22)" fill="white" />
    <rect width="8.25" height="4.125" transform="matrix(-1 1.04907e-06 -2.91409e-08 -1 22 22)" fill="white" />
    <rect x="17.875" y="22" width="8.25" height="4.125" transform="rotate(-90 17.875 22)" fill="white" />
  </Svg>
)

export default Icon
